import Add from "../../../features/companies/Add";

const AddCompany = () => {
	return <Add />;
};

export default AddCompany;
